import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Button } from '@material-ui/core';
import ShareIcon from '@material-ui/icons/Share';
import { Link } from 'react-router-dom';

import bookmark from './images/yellow-bookmark.png';

export default class CrdJob extends Component {
    render() {
        return (
            <Row className="m-0 mb-3">
                <Col md='12' className="p-0" style={{ borderBottom: '1px solid #f2f2f2' }}>
                    <div className="pt-3 pb-3">
                        <Row className="justify-content-center m-0">
                            <Col md={1} xs={7} className="order-sm-1 order-2 text-center p-0">
                                <img src="https://via.placeholder.com/150" alt="interview img" className="img-fluid rounded text-left mb-3" />
                            </Col>
                            <Col md={11} xs={12} className="order-sm-2 order-3 text-left">
                                <Row className="m-0">
                                    <Col md='8' className="order-sm-1 order-2 p-0  d-inline-block">
                                        <h5>UX/UI Designer</h5>
                                        <p className="text-orange mb-0 pr-1">New Horizon </p>
                                        <p className="text-grey mb-0"> 13 Nov 2019</p>
                                        {/* <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumyt <Link to="/" className="text-orange underline">See More</Link></p> */}
                                    </Col>
                                    <Col md='4' className="text-right order-sm-2 p-0 order-1 mb-1 d-inline-block text-responsive-right">
                                        <Button size="small" variant="outlined" className="btn-orange-outline-gradiant" color="primary">
                                            <ShareIcon /> share
                                        </Button>
                                        <Link className="pl-3">
                                            <img src={bookmark} className="btn-bookmark" width="20" alt="bookmark" />
                                        </Link>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        )
    }
}